// --- services/geocode.js ---
const GOOGLE_KEY = "AIzaSyCZKd9GsscBfVyRmXv1azAVbTlh0qPnfGc"; // ⚠️ à sécuriser (voir note en bas)

export async function geocodeAddressFR(fullAddress) {
  const url =
    "https://maps.googleapis.com/maps/api/geocode/json" +
    `?address=${encodeURIComponent(fullAddress)}` +
    `&components=country:FR&language=fr&key=${GOOGLE_KEY}`;
  const r = await fetch(url);
  const data = await r.json();
  if (data.status !== "OK" || !data.results?.length) {
    throw new Error(data.error_message || data.status);
  }
  return data.results; // liste de candidats
}

export async function reverseGeocodeFR(lat, lng) {
  const url =
    "https://maps.googleapis.com/maps/api/geocode/json" +
    `?latlng=${lat},${lng}&result_type=street_address&language=fr` +
    `&key=${GOOGLE_KEY}`;
  const r = await fetch(url);
  const data = await r.json();
  if (data.status !== "OK" || !data.results?.length) {
    throw new Error(data.error_message || data.status);
  }
  return data.results[0];
}
